import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const deleteIdentityProviderTE = <E = CF.API.ApiError>(
  { orgId, identityProviderId }: { orgId: string; identityProviderId: string },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.BaseResponse> =>
  fetchTE<CF.API.BaseResponse, E>(
    {
      path: `/api/_api/v2/organizations/${orgId}/identity_providers`,
      method: 'DELETE',
      body: {
        ids: [identityProviderId],
      },
    },
    onRejected,
  );
